/**
 * Events archive: client-side search and category filter (events only).
 * Debounced text search; category filter toggles; realtime show/hide of cards.
 *
 * @package MorrFitHP
 */

(function () {
  const DEBOUNCE_MS = 280;
  const GRID_SEL = '#events-archive-grid';
  const CARD_SEL = '.js-event-card';
  const NO_RESULTS_SEL = '#events-archive-no-results';
  const SEARCH_INPUT_SEL = '#event-search';
  const CATEGORY_BTN_SEL = '[data-event-category-filter]';

  const grid = document.querySelector(GRID_SEL);
  const searchInput = document.querySelector(SEARCH_INPUT_SEL);
  const noResults = document.querySelector(NO_RESULTS_SEL);

  if (!grid || !searchInput) return;

  const cards = Array.from(grid.querySelectorAll(CARD_SEL));

  function debounce(fn, ms) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), ms);
    };
  }

  function getSearchQuery() {
    return (searchInput.value || '').trim().toLowerCase();
  }

  function getSelectedCategory() {
    const btn = document.querySelector(CATEGORY_BTN_SEL + '[aria-pressed="true"]');
    return btn ? (btn.getAttribute('data-event-category-filter') || '') : '';
  }

  function cardMatchesSearch(card, query) {
    if (!query) return true;
    const id = (card.getAttribute('data-event-id') || '').toLowerCase();
    const title = (card.getAttribute('data-event-title') || '').toLowerCase();
    const location = (card.getAttribute('data-event-location') || '').toLowerCase();
    const categoryName = (card.getAttribute('data-event-category-name') || '').toLowerCase();
    const searchable = [id, title, location, categoryName].join(' ');
    return searchable.indexOf(query) !== -1;
  }

  function cardMatchesCategory(card, categorySlug) {
    if (!categorySlug) return true;
    const cardSlug = card.getAttribute('data-event-category') || '';
    return cardSlug === categorySlug;
  }

  function applyFilters() {
    const query = getSearchQuery();
    const category = getSelectedCategory();
    let visibleCount = 0;

    cards.forEach(function (card) {
      const matchSearch = cardMatchesSearch(card, query);
      const matchCategory = cardMatchesCategory(card, category);
      const show = matchSearch && matchCategory;
      card.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });

    if (noResults) {
      noResults.classList.toggle('hidden', visibleCount > 0);
    }
  }

  function initCategoryButtons() {
    document.querySelectorAll(CATEGORY_BTN_SEL).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll(CATEGORY_BTN_SEL).forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
          b.classList.remove('bg-primary', 'text-white', 'border-primary');
          b.classList.add('bg-background-dark', 'border-slate-700', 'text-slate-400');
        });
        btn.setAttribute('aria-pressed', 'true');
        btn.classList.remove('bg-background-dark', 'border-slate-700', 'text-slate-400');
        btn.classList.add('bg-primary', 'text-white', 'border-primary');
        applyFilters();
      });
    });
  }

  function initSearch() {
    searchInput.addEventListener('input', debounce(applyFilters, DEBOUNCE_MS));
    searchInput.addEventListener('search', debounce(applyFilters, DEBOUNCE_MS));
  }

  function initFormPreventSubmit() {
    const form = searchInput.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFilters();
      });
    }
  }

  function initFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const slug = params.get('event_category');
    if (!slug) return;
    const btn = document.querySelector(CATEGORY_BTN_SEL + '[data-event-category-filter="' + CSS.escape(slug) + '"]');
    if (!btn) return;
    document.querySelectorAll(CATEGORY_BTN_SEL).forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.classList.remove('bg-primary', 'text-white', 'border-primary');
      b.classList.add('bg-background-dark', 'border-slate-700', 'text-slate-400');
    });
    btn.setAttribute('aria-pressed', 'true');
    btn.classList.remove('bg-background-dark', 'border-slate-700', 'text-slate-400');
    btn.classList.add('bg-primary', 'text-white', 'border-primary');
  }

  initFromUrl();
  initCategoryButtons();
  initSearch();
  initFormPreventSubmit();
  applyFilters();
})();
